// src/pages/Blog.jsx
import React from "react";
import { Link } from "react-router-dom";
import "../css/Blog.css";

import Blog1 from "../assets/pgimagesnew2/IMG-20250923-WA0018.jpg";
import Blog2 from '../assets/pgimagesnew2/IMG-20250923-WA0014.jpg';
import Blog3 from '../assets/pgimagesnew2/IMG-20250923-WA0024.jpg';
import Blog4 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.41.14 PM.jpeg';
import Blog5 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.15 PM.jpeg';
import Blog6 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.30 PM.jpeg';
import Blog7 from '../assets/pgimagesnew2/IMG-20250923-WA0013.jpg';
import Blog8 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.22 PM.jpeg';
import Blog9 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.41.14 PM.jpeg';
import Blog10 from '../assets/pgimagesnew/IMG-20250918-WA0020.jpg';
import Blog11 from '../assets/pgimagesnew2/IMG-20250923-WA0025.jpg';
import Blog12 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.30 PM.jpeg';
import Blog13 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.23 PM (1).jpeg';
import Blog14 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.06 PM.jpeg';
import Blog15 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.30 PM (1).jpeg';
import Blog16 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.30 PM (2).jpeg';
import Blog17 from '../assets/pgimagesnew2/IMG-20250923-WA0015.jpg';
import Blog18 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.15 PM.jpeg';
import Blog19 from '../assets/pgimagesnew2/IMG-20250923-WA0022.jpg';
import Blog20 from '../assets/gallery/WhatsApp Image 2025-07-08 at 2.45.32 PM.jpeg';
import Blog21 from '../assets/pgimagesnew2/IMG-20250923-WA0018.jpg';
import Blog22 from '../assets/pgimagesnew/IMG-20250918-WA0020.jpg';
import Blog23 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.17 PM.jpeg';
import Blog24 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.26 PM.jpeg';
import Blog25 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.41.14 PM.jpeg';
import Blog26 from '../assets/pgimagesnew2/IMG-20250923-WA0014.jpg';
import Blog27 from '../assets/pgimagesnew/IMG-20250918-WA0020.jpg';
import Blog28 from '../assets/pgimagesnew3/3.jpeg';
import Blog29 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.15 PM.jpeg';
import Blog30 from '../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.30 PM (1).jpeg';

const getTags = (post) => {

  const tags = [];
  const today = new Date();
  const postDate = new Date(post.date);

  const diffDays = (today - postDate) / (1000 * 60 * 60 * 24);

  // NEW tag (auto)
  if (diffDays <= 7) {
    tags.push("New");
  }

  // random tags pool
  const extraTags = ["Popular", "Featured", "Best Guide"];

  extraTags.forEach(tag => {
    if (Math.random() > 0.6) {
      tags.push(tag);
    }
  });

  // decide how many tags to show
  const r = Math.random();

  let maxTags = 1;

  if (r > 0.5) maxTags = 2;
  if (r > 0.9) maxTags = 3;

  return tags.slice(0, maxTags);
};

// single sample post (you can add more objects to this array)
const POSTS = [
  {
  id: "smart-pg-vs-traditional-pg-mumbai-2026",
  title: "Smart PG vs Traditional PG: Why Mumbai Renters Are Switching in 2026",
  date: "14 Mar 2026",
  image: Blog30,

  excerpt:
    "Mumbai: The way young renters choose accommodation in Mumbai is undergoing a significant shift in 2026. With rising migration, increased safety awareness, and evolving lifestyle expectations, the traditional paying guest (PG) model is steadily giving way to a new alternative — the Smart PG.",
},
  {
  id: "value-for-money-living-malad-east-2026-guide",
  title: "Value for Money Living: What to Expect from PG Living in Malad East (2026 Guide)",
  date: "12 Mar 2026",
  image: Blog29,

  excerpt:
    "Malad East has become one of Mumbai’s most preferred residential areas for students and working professionals seeking shared accommodation. With growing migration and demand for safe housing, many renters are now exploring Malad East for its balance of comfort, connectivity, and livability.  ",
},
  {
  id: "top-safety-features-every-girls-pg-must-have",
  title: "Top Safety Features Every Girls PG in Mumbai Must Have",
  date: "10 Mar 2026",
  image: Blog28,
  excerpt:
    "Safety is the most important factor when choosing accommodation, especially for women living independently in metro cities. A well-secured PG not only provides peace of mind but also creates a comfortable environment where residents can focus on their careers or studies. If you are searching for the Best Girls PG in Malad, Goregoan and Kandivali, understanding essential safety features will help you make the right decision.",
},
  {
  id: "importance-of-female-only-pgs-in-metro-cities-like-mumbai",
  title: "The Importance of Female-Only PGs in Metro Cities Like Mumbai",
  date: "09 Mar 2026",
  image: Blog27,
  excerpt:
    "Metro cities like Mumbai attract thousands of women every year for education, careers, and personal growth. While these opportunities open doors, they also bring challenges—especially when it comes to finding safe and reliable accommodation. This is where female-only PGs play a crucial role in supporting independent living for women in fast-paced urban environments.",
},
  {
  id: "how-a-well-maintained-pg-improves-productivity-for-working-women",
  title: "How a Well-Maintained PG Improves Productivity for Working Women",
  date: "07 Mar 2026",
  image: Blog26,
  excerpt:
    "In a fast-moving city like Mumbai, working women juggle long office hours, commuting, and personal responsibilities. In such a demanding lifestyle, the quality of living space plays a major role in daily efficiency and mental well-being. A well-maintained PG accommodation is more than just a place to stay—it directly impacts productivity, focus, and overall quality of life.",
},
  {
  id: "hidden-charges-in-pg-accommodations-how-zero-brokerage-saves-you-money",
  title: "Hidden Charges in PG Accommodations: How Zero Brokerage Saves You Money",
  date: "16 Feb 2026",
  image: Blog25,
  excerpt:
    "Finding a paying guest accommodation in Mumbai can be challenging, especially when unexpected costs appear after you move in. Many girls searching for PG accommodation face hidden charges that significantly increase monthly expenses. If you are looking for the Best PG in Malad, Goregoan and Kandivali Mumbai, understanding these hidden costs and choosing a zero brokerage PG can help you save a substantial amount of money.",
},
  {
  id: "best-girls-pg-in-mumbai-complete-guide-safe-comfortable-living",
  title: "Best Girls PG in Mumbai – A Complete Guide for Safe & Comfortable Living",
  date: "13 Feb 2026",
  image: Blog24,
  excerpt:
    "Finding the best girls PG in Mumbai can be challenging, especially for students and working women who are new to the city. Safety, comfort, location, and affordability are top priorities when choosing a paying guest accommodation. Mumbai is a fast-paced city, and having a secure, well-maintained PG can make daily life much easier and stress-free.",
},
  {
  id: "best-areas-in-malad-east-for-girls-pg-accommodation",
  title: "Best Areas in Malad, Goregoan and Kandivali for Girls PG Accommodation",
  date: "11 Feb 2026",
  image: Blog23,
  excerpt:
    "Malad, Goregoan and Kandivali has rapidly become one of Mumbai’s most preferred residential zones for girls seeking safe and convenient PG accommodation. With excellent connectivity, established neighborhoods, and easy access to workplaces and colleges, the area offers multiple pockets ideal for students and working women.",
},
  {
  id: "affordable-girls-pg-mumbai-safe-budget-friendly-living",
  title: "Affordable Girls PG Mumbai – Safe & Budget-Friendly Living for Girls",
  date: "9 Feb 2026",
  image: Blog22,
  excerpt:
    "Mumbai is known as the city of dreams, but it is also one of the most expensive cities to live in. For students and working women moving to Mumbai, finding safe and budget-friendly accommodation is a major concern. This is where affordable girls PG in Mumbai becomes the best solution.",
},
  {
  id: "why-working-women-prefer-pgs-over-shared-apartments",
  title: "Why Working Women Prefer PGs Over Shared Apartments",
  date: "06 Feb 2026",
  image: Blog21,
  excerpt:
    "In fast-paced metro cities like Mumbai, working women are increasingly choosing PG accommodations over shared apartments. The reasons go beyond affordability—PGs offer convenience, safety, and peace of mind, which are essential for professionals managing demanding work schedules.",
},
  {
  id: "what-defines-a-reliable-girls-pg-in-mumbai",
  title: "What Defines a Reliable Girls PG in Mumbai?",
  date: "04 Feb 2026",
  image: Blog20,
  excerpt:
    "Finding a dependable place to stay is a top priority for women moving to a metro city like Mumbai for work or education. With rising demand for safe and comfortable accommodation, choosing a reliable girls PG has become more important than ever. From safety standards to daily convenience, several factors determine whether a PG truly meets the needs of modern women.",
},
  {
  id: "top-rated-girls-pg-in-mumbai-safe-comfortable-affordable-living",
  title: "Top-Rated Girls PG in Mumbai – Safe, Comfortable & Affordable Living",
  date: "02 Feb 2026",
  image: Blog19,
  excerpt:
    "Mumbai, the city of dreams, attracts thousands of students and working women every year. Whether you're relocating for studies, a new job, or career growth, finding the right accommodation is one of the biggest challenges. Safety, comfort, affordability, and location all matter — and that’s why choosing a top-rated girls PG in Mumbai becomes essential.",
},
  {
  id: "girls-pg-near-malad-railway-station-what-to-look-for",
  title: "Girls PG Near Malad Railway Station: What to Look for Before You Choose",
  date: "22 Dec 2025",
  image: Blog18,
  excerpt:
    "Finding the right Girls PG near Malad Railway Station can make a huge difference in your daily routine, safety, and overall quality of life—especially if you are a student or a working professional in Mumbai. With Malad, Goregoan and Kandivali being one of the city’s busiest and most well-connected suburbs, the demand for reliable girls’ PG accommodation continues to grow.",
},

  {
  id: "pg-living-vs-hostel-living-for-girls-mumbai",
  title: "PG Living vs Hostel Living for Girls: Which Is Better in Mumbai?",
  slug: "pg-living-vs-hostel-living-for-girls-mumbai",
  date: "19 Dec 2025",
  image: Blog17,
  excerpt:
    "Mumbai is a city of opportunities, attracting thousands of girls every year for education, careers, and professional growth. However, one of the biggest challenges after moving to Mumbai is choosing the right accommodation. Girls often find themselves confused between PG living and hostel living.",
},

  {
  id: "common-problems-girls-face-in-pgs-and-how-to-avoid-them",
  title: "Common Problems Girls Face in PGs and How to Avoid Them",
  date: "17-12-2025",
  image: Blog16, // make sure you import blog16 image
  excerpt:
    "Moving to a new city like Mumbai for education or work is an exciting step, but finding the right PG accommodation can be challenging—especially for girls. Many girls face unexpected issues after moving into a PG, ranging from safety concerns to hidden costs and poor living conditions. Knowing these common problems in advance can help you make a smarter, stress-free decision.",
},

  {
  id: "why-malad-east-top-location-for-girls-pgs",
  title: "Why Malad, Goregoan and Kandivali Is a Top Location for Girls PGs in Mumbai",
  date: "15 Dec 2025",
  image: Blog15, // add image import
  excerpt:
    "Finding the right place to live in Mumbai is a major decision, especially for girls who prioritize safety, convenience, and comfort. Among the many localities in the city, Malad, Goregoan and Kandivali has emerged as one of the most preferred areas for girls PG accommodation. Its strategic location, excellent connectivity, and well-developed infrastructure make it ideal for students and working women alike.",
},

  {
  id: "looking-for-girls-pg-in-malad-east-mumbai",
  title: "Looking for a Girls PG in Malad, Goregoan and Kandivali, Mumbai? Choose No Brokerage for a Hassle-Free Stay",
  date: "12 Dec 2025",
  image: Blog14, // use correct blog image filename
  excerpt:
    "Finding the right Girls PG in Malad, Goregoan and Kandivali, Mumbai can feel overwhelming—especially when you’re looking for a place that is safe, affordable, clean, and comfortable. With countless options across the suburb, it becomes difficult to identify which PG actually delivers what it promises.",
},

  {
    id: "top-rated-girls-pg-in-malad-east-mumbai",
    title:
      "Top-Rated Girls PG in Malad, Goregoan and Kandivali, Mumbai | No Brokerage, Hygienic Meals & 24×7 Security",
    date: "10 Dec 2025",
    image: Blog13,
    excerpt:
      "Finding a safe, comfortable, and budget-friendly Girls PG in Malad, Goregoan and Kandivali, Mumbai can be challenging—especially when you're moving to a new city or starting a new job. With countless PG options and varying standards of quality, choosing a reliable accommodation becomes even more important.",
  },
  {
  id: "why-no-brokerage-paying-guest-number1-choice",
  title: "Why No Brokerage Paying Guest is the #1 Choice for Girls PG in Malad, Goregoan and Kandivali",
  date: "08 Dec 2025",
  image: Blog12, // your image
  excerpt:
    "Why No Brokerage Paying Guest is the #1 Choice for Girls PG in Malad, Goregoan and Kandivali Finding a safe, comfortable, and affordable Girls PG in Malad, Goregoan and Kandivali, Mumbai can be overwhelming, especially when you’re new to the city or shifting your residence for studies or work. With so many PGs and hostels available, identifying the right one that offers security, convenience, and value for money becomes crucial.",
},

  {
  id: "top-girls-pg-in-malad-east-mumbai",
  title: "Top Girls PG in Malad, Goregoan and Kandivali, Mumbai | Experience Comfort & Safety with No Brokerage",
  date: "05 Dec 2025",
  image: Blog11,
  excerpt: "Finding the Best Girls PG in Malad, Goregoan and Kandivali, Mumbai can be challenging, especially when safety, affordability, cleanliness, and convenience all matter equally. Whether you are a student, a working professional, or someone moving to Mumbai for the first time, choosing the right accommodation plays a major role in how comfortable and stress-free your daily life becomes.",
},

  {
  id: "live-smart-safe-no-brokerage-paying-guest",
  title: "Live Smart & Safe: Explore No Brokerage Paying Guest in Malad, Goregoan and Kandivali, Mumbai",
  date: "03 Dec 2025",
  image: Blog10,
  excerpt:
    "Finding the right accommodation in Mumbai can be challenging, especially for girls who value safety, affordability, and cleanliness. Malad, Goregoan and Kandivali, one of Mumbai’s most preferred residential and commercial hubs, attracts students and working women from across India. But with so many PG options available, choosing the perfect one becomes confusing.",
},
  {
  id: "find-your-perfect-pg-in-malad-east",
  title: "Find Your Perfect PG in Malad, Goregoan and Kandivali | Secure Girls Accommodation With No Brokerage",
  date: "01 Dec 2025",
  image: Blog9,
  excerpt:
    "Finding the ideal place to stay in Mumbai can feel overwhelming — especially for girls looking for a home that is secure, affordable, and comfortable. With rising rentals, hidden charges, and brokerage fees, choosing a safe and trusted accommodation becomes even more challenging. That's where No Brokerage Paying Guest in Malad, Goregoan and Kandivali, Mumbai helps make the journey easier, safe, and stress-free.",
},
  {
  id: "experience-hassle-free-living-in-malad-east",
  title: "Experience Hassle-Free Living at No Brokerage Paying Guest in Malad, Goregoan and Kandivali, Mumbai",
  date: "28 Nov 2025",
  image: Blog8,
  excerpt:
    "Finding a safe, comfortable, and affordable living space in Mumbai—especially for girls—can feel overwhelming. With rising rental costs, brokerage fees, and limited secure accommodations, many students and working professionals struggle to find the right place to call home. That’s exactly where No Brokerage Paying Guest in Malad, Goregoan and Kandivali steps in as a trusted solution.",
},
  {
  id: "safe-affordable-girls-pg-in-malad-east",
  title: "Safe & Affordable Girls PG in Malad, Goregoan and Kandivali | Stay at No Brokerage Paying Guest",
  date: "26 Nov 2025",
  image: Blog7,
  excerpt:
    "Finding the right accommodation in Mumbai can be overwhelming—especially for girls who want a place that is safe, affordable, and comfortable. If you're a student, fresher, or working professional looking for a girls PG in Mumbai, then No Brokerage Paying Guest in Malad, Goregoan and Kandivali is the ideal choice for you. With zero brokerage, modern amenities, and a secure environment, it offers everything needed for a stress-free and enjoyable living experience.",
},
  {
  id: "girls-pg-in-malad-east-zero-brokerage",
  title: "Girls PG in Malad, Goregoan and Kandivali With Zero Brokerage | Secure, Comfortable, and Modern Living",
  date: "24 Nov 2025",
  image: Blog6,
  excerpt:
    "Girls PG in Malad, Goregoan and Kandivali With Zero Brokerage | Secure, Comfortable, and Modern Living Finding a safe and comfortable home in Mumbai can be overwhelming—especially for girls relocating for studies or work. With rising brokerage costs, unclear rental terms, and unsafe accommodation options, the search becomes even more stressful.",
},
  {
  id: "your-ideal-co-living-space-in-malad-east",
  title: "Your Ideal Co-Living Space in Malad, Goregoan and Kandivali | No Brokerage Girls PG in Mumbai",
  date: "21 Nov 2025",
  image: Blog5,
  excerpt: "Finding a safe, comfortable, and affordable living space in Mumbai can be challenging—especially for girls looking for a secure and supportive environment. At No Brokerage Paying Guest, we redefine co-living with modern amenities, zero brokerage, and a homely atmosphere right in the heart of Malad, Goregoan and Kandivali.",
},
  {
  id: "no-brokerage-paying-guest-safe-affordable-modern-pg",
  title: "No Brokerage Paying Guest – Safe, Affordable & Modern PG for Girls in Malad, Goregoan and Kandivali, Mumbai",
  date: "19 Nov 2025",
  image: Blog4,
  excerpt:
    "Finding a safe, comfortable, and budget-friendly PG for girls in Mumbai can be challenging—especially when you want a trusted place without paying heavy brokerage fees.",
},
    {
  id: "best-girls-pg-in-malad-east-mumbai",
  title: "Best Girls PG in Malad, Goregoan and Kandivali, Mumbai | No Brokerage, Safe & Comfortable Living",
  date: "17 Nov 2025",
  image: Blog3,  
  excerpt:
    "Finding the right accommodation in Mumbai can feel overwhelming, especially for young women moving for studies or work. Safety, comfort, affordability, and a friendly environment are essentials that cannot be compromised.",
},
    {
  id: "discover-no-brokerage-paying-guest-malad-east",
  title: "Discover No Brokerage Paying Guest – The Best Girls PG in Malad, Goregoan and Kandivali, Mumbai",
  date: "14 Nov 2025",
  image: Blog2,
  excerpt: "Finding a perfect Girls PG in Malad, Goregoan and Kandivali, Mumbai can be challenging — balancing safety, comfort, affordability, and convenience isn’t easy in a city that never sleeps.",
},
  {
    id: "find-the-perfect-girls-pg-in-malad-east",
    title:
      "Find the Perfect Girls PG in Malad, Goregoan and Kandivali, Mumbai – No Brokerage, Fully Furnished & Secure",
    date: "14 Nov 2025",
    image: Blog1,
    excerpt:
      "Finding a safe, comfortable, and affordable PG in Malad, Goregoan and Kandivali, Mumbai can often feel like a challenge — especially when you’re searching for a place that feels like home and doesn’t involve hefty brokerage fees.",
  },

];

export default function Blog() {
  return (
    <main className="blog-page">
  <div className="container blog-header">
    <h1>Blogs</h1>
    <p>Helpful articles and updates — read our latest posts.</p>
  </div>

  <div className="container blog-grid">
    {POSTS.map((post) => (
      <article className="blog-card" key={post.id}>
        
        {/* IMAGE */}
            <div className="blog-image-wrapper">

  <Link to={`/blog/${post.id}`} className="blog-card-img">
    <img src={post.image} alt={post.title} />
  </Link>

  <div className="blog-tags">
    {getTags(post).map((tag, i) => (
      <span key={i} className={`blog-tag ${tag.toLowerCase().replace(" ", "-")}`}>
        {tag}
      </span>
    ))}
  </div>

</div>

        <div className="blog-card-content">
          <h2 className="blog-card-title">
            <Link to={`/blog/${post.id}`} style={{ textDecoration: "none" }}>
              {post.title}
            </Link>
          </h2>

          <span className="blog-date">{post.date}</span>

          <p className="blog-excerpt">{post.excerpt}</p>

          <Link to={`/blog/${post.id}`} className="blog-btn">
            Read More →
          </Link>
        </div>

      </article>
    ))}
  </div>
</main>
  );
}